<template>
  <el-container class="ExpensePrint">
    <el-main ref="ExpensePrintArea" class="p-0 ExpensePrintArea">
      <div
        v-for="(sdata, index) in slice_items" 
        class="w-full print-divider pb-default"
        :key="sdata.id" 
      >
        <div id="excel_table">
          <table class="w-full">
            <tr>
              <td colspan="13" style="font-size:35px; font-weight:bold; text-align:center;">거 래 내 역 리 스 트</td>
            </tr>
            <tr></tr>
          </table>
          <table class="w-full border transaction" cellspacing="0" cellpadding="2" style="border-bottom:none;">
            <col width="2%"/>
            <col width="8%"/>
            <col width="15%"/>
            <col width="8%"/>
            <col width="17%"/>
            <col width="2%"/>
            <col width="8%"/>
            <col width="15%"/>
            <col width="8%"/>
            <col/>
            <col/>
            <col/>
            <col/>
            <tr>
              <!-- 공급받는자 -->
              <th rowspan="4">공 급 받 는 자</th>
              <th>인 쇄 일</th>
              <td style="text-align:left;">{{util.getDate()}}</td>
              <th>검색기간</th>
              <td>{{period.startDate}} - {{period.endDate}}</td>
              <!-- 공급자 -->
              <th rowspan="4">공 급 자</th>
              <th style="min-width: 70px;">등록번호</th>
              <td colspan="6">{{company.crn}}</td>  
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>소재지</th>
              <td colspan="3">{{customer.addr}}</td>
              <!-- 공급자 -->
              <th>소재지</th>
              <td colspan="6"><AFitText>{{company.addr}}</AFitText></td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>상 호</th>
              <td colspan="3" class="bold">{{customer.name}}<span class="ml-default"> 귀중</span></td>
              <!-- 공급자 -->
              <th>상호</th>
              <td colspan="6" style="min-width: 180px;">{{company.name}}</td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>연락처</th>
              <td style="min-width: 100px;">{{customer.tel}}</td>
              <th style="min-width: 40px;">팩 스</th>
              <td style="min-width: 70px;">{{customer.fax}}</td>
              <!-- 공급자 -->
              <th>전 화</th>
              <td style="min-width: 100px;">{{company.tel}}</td>
              <th style="min-width: 40px;">팩 스</th>
              <td colspan="4" style="min-width: 70px;" >{{company.fax}}</td>
            </tr>
            <tr></tr>
          </table>
          <div class="none">
            <table class="w-full border table-fs12 print-list table-fixed" cellspacing="0" cellpadding="3">
              <col width="30"/>
              <col width="90"/>
              <col width="120"/>
              <col width="100"/>
              <col width="40"/>
              <col width="40"/>
              <col width="70"/>
              <col width="80"/>
              <col width="80"/>
              <col width="80"/>
              <col width="80"/>
              <col/>
              <col/>
              <tr>
                <th>No</th>
                <th>거래일</th>
                <th>품목</th>
                <th>{{$t('lang.size')}}</th>
                <th>수량</th>
                <th>단위</th>
                <th>단가</th>
                <th>공급가액</th>
                <th>세액</th>
                <th>금액</th>
                <th>미수금</th>
                <th>현장</th>
                <th>비고</th>
              </tr>
              <tr 
                v-for="(item, i) in data" 
                v-bind:key="item.id"
                v-bind:class="{mark: item.type_flag === '2', 'day-sum-row' : item.sum_row }"
              >
                <td class="align-center">{{i+1}}</td>
                <td class="align-center">{{item.deal_date}}</td>
                <td class="mark"><div class="ellipsis">{{item.product_name}}</div></td>
                <td><div class="ellipsis">{{item.size}}</div></td>
                <td class="align-center">{{util.addComma(item.amount)}}</td>
                <td class="align-center mark">{{item.unit_name}}</td>
                <td class="cell-number">{{util.addComma(item.cost)}}</td>
                <td class="cell-number">{{util.addComma(item.supply_price)}}</td>
                <td class="cell-number">{{util.addComma(item.tax)}}</td>
                <td class="cell-number mark">{{util.addComma(item.price)}}</td>
                <td class="cell-number">{{util.addComma(item.balance)}}</td>
                <td><div class="ellipsis">{{item.field}}</div></td>
                <td><div class="ellipsis">{{item.desc}}</div></td>
              </tr>
            </table>
          </div>
        </div>    
        <div 
          class="max-height of-auto mt-default"
          v-bind:class="{'of-hidden': of_hidden}"   
        >
          <table class="w-full border table-fs12 print-list mt-default table-fixed" cellspacing="0" cellpadding="3">
            <col width="30"/>
            <col width="100"/>
            <col width="120"/>
            <col width="100"/>
            <col width="45"/>
            <col width="40"/>
            <col width="80"/>
            <col width="90"/>
            <col width="90"/>
            <col width="90"/>
            <col width="90"/>
            <col/>
            <col/>
            <tr>
              <th>No</th>
              <th>거래일</th>
              <th>품목</th>
              <th>{{$t('lang.size')}}</th>
              <th>수량</th>
              <th>단위</th>
              <th>단가</th>
              <th>공급가액</th>
              <th>세액</th>
              <th>금액</th>
              <th>미수금</th>
              <th>현장</th>
              <th>비고</th>
            </tr>
            <tr 
              v-for="(item, i) in sdata.items" 
              v-bind:key="item.id"
              v-bind:class="{mark: item.type_flag === '2', 'day-sum-row' : item.sum_row }"
            >
              <td class="align-center">{{i + 1}}</td>
              <td class="align-center">{{displayDealDate(index, i)}}</td>
              <td class="mark"><div class="ellipsis">{{item.product_name}}</div></td>
              <td><div class="ellipsis">{{item.size}}</div></td>
              <td class="align-center">{{util.addComma(item.amount)}}</td>
              <td class="align-center mark">{{item.unit_name}}</td>
              <td class="cell-number">{{util.addComma(item.cost)}}</td>
              <td class="cell-number">{{util.addComma(item.supply_price)}}</td>
              <td class="cell-number">{{util.addComma(item.tax)}}</td>
              <td class="cell-number mark">{{util.addComma(item.price)}}</td>
              <td class="cell-number">{{util.addComma(item.balance)}}</td>
              <td><div class="ellipsis">{{item.field}}</div></td>
              <td><div class="ellipsis">{{item.desc}}</div></td>
            </tr>
          </table>
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="handleClickExcel">양식 다운로드</el-button>
      <el-button @click="handlClickBomExcel">데이터 다운로드</el-button>      
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import export2csv from "@/common/function/export2csv";
import { mapGetters } from "vuex";
import Vue from "vue";
import Print from "@/plugins/print/print";
import { company_info } from "@/common/mixins/company_info";
import AFitText from '@/shared/AFitText';

Vue.use(Print);

export default {
  name: "ExpensePrint",
  components: {AFitText, },
  mixins: [company_info, ],
  data() {
    return {
      title: '거래내역리스트',
      items: [],
      of_hidden: false,
      is_printed: false,
    };
  },
  props: {
    period: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    last_item: {
      type: Object,
    },
    data: {
      type: Array,
      required: true
    },
    sum_flag: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(["table_config"]),
    slice_items() {
      let items = [];
      let cur_items;
      let index = 0;      
      this.items.forEach(item => {
        if (index % 24 === 0) {
          cur_items = {
            id: index,
            items: [],
          };
          items.push(cur_items);
        }
        cur_items.items.push(item);
        index++;
      });
      items.forEach(item => {
        item.account = this.parseAccount(item);
      });
      return items;
    },
  },
  mounted() {
    this.calculatePrice();
    this.loadConfig();
  },
  methods: {
    displayDealDate(sIndex, index) {
      let sItem = this.slice_items[sIndex];
      if (index === 0) {
        return sItem.items[index].deal_date;
      }
      if (sItem.items[index - 1].deal_date === sItem.items[index].deal_date) {
        if (sItem.items[index].sum_row) {
          return sItem.items[index].deal_date;
        }
        return ""
      } else {
        return sItem.items[index].deal_date;
      }
    },
    calculatePrice() {
      this.items = Object.assign([], this.data);
      let total_supply_price = 0;
      let total_tax = 0;
      let total_price = 0;
      let last_balance = 0;
      if (this.sum_flag === true) {
        let day_old = '';
        let day_cur = '';
        let day_supply_price = 0;
        let day_tax = 0;
        let day_price = 0;
        let day_balance = 0;
        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i];
          day_cur = item.deal_date;
          if (day_old !== day_cur) {
            if (day_old !== '') {
              this.items.splice(i, 0, {
                sum_row: true,
                deal_date: day_old,
                product_name: '소 계',
                supply_price: day_supply_price,
                tax: day_tax,
                price: day_price,
                balance: day_balance,
              });
              day_supply_price = 0;
              day_tax = 0;
              day_price = 0;
              day_balance = 0;
              i++;
            }
            day_old = day_cur;
          }
          if (item.type_flag === "1") {
            day_supply_price += item.supply_price;
            day_tax += item.tax;
            day_price += item.price;         
          }
          day_balance = item.balance;
        }
        if (this.items.length > 0 && !this.items[this.items.length -1].sum_row) {
          this.items.splice(this.items.length + 1, 0, {
            sum_row: true,
            product_name: '소 계',
            supply_price: day_supply_price,
            tax: day_tax,
            price: day_price,
            balance: day_balance,
          });
        }
      }
      this.items.forEach(item => {
        if (item.type_flag === "1") {
          total_supply_price += item.supply_price;
          total_tax += item.tax;
          total_price += item.price;
        }
        last_balance = item.balance;
      });
      this.items.splice(this.items.length + 2, 0, {        
        sum_row: true,
        total_sum: true,        
        product_name: '전체 소계',
        supply_price: total_supply_price,
        tax: total_tax,
        price: total_price,
        balance: last_balance,
      });        
    },
    parseAccount(data) {
      let pre_balance = 0;
      let balance = 0;
      let expense = 0;
      let total = 0;
      if (data.items[0].sum_row) {
        // 첫 번쨰 행이 소계라면
        pre_balance = data.items[0].balance;        
      } else if (data.items[0].type_flag === '2') {
        // 첫 번째 행이 수금이라면
        pre_balance = data.items[0].balance + data.items[0].price;
      } else {
        pre_balance = data.items[0].balance - data.items[0].price
      }
      if (this.sum_flag && data.items[data.items.length -2]) {
        balance = data.items[data.items.length -2].balance;
        if (data.items[data.items.length -1].sum_row 
        && !data.items[data.items.length -1].total_sum) {
          // 마지막 행이 소계라면
          balance = data.items[data.items.length -3].balance;
        }
      }
      data.items.forEach(item => {
        if (item.expense) {
          expense += item.expense;
        }
        if (item.type_flag === '1') {
          total += item.price;
        }
      });
      return {
        pre_balance: pre_balance,
        expense: expense,
        total: total,
        balance: balance,
      }
    },
    handleClickPrint() {
      this.of_hidden = true;
      this.is_printed = true;
      this.$print(this.$refs.ExpensePrintArea);
    },
    handleClickClose() {
      this.$emit('completed', this.is_printed);
    },
    handlClickBomExcel() {
      let items = [];
      let fields = [
        { value: 'deal_date', label: '거래일' },
        { value: 'product_name', label: '품목' },
        { value: 'size', label: '규격' },
        { value: 'amount', label: '수량' },
        { value: 'unit_name', label: '단위' },
        { value: 'cost', label: '단가' },
        { value: 'supply_price', label: '공급가액' },
        { value: 'tax', label: '세액' },
        { value: 'price', label: '금액' },
        { value: 'balance', label: '미수금' },
        { value: 'field', label: '현장' },
        { value: 'desc', label: '비고' },
      ];
      this.data.forEach(d => {
        let data = {
          deal_date: d.deal_date,
          product_name: d.product_name,
          size: d.size,
          amount: d.amount,
          unit_name: d.unit_name,
          cost: d.cost,
          supply_price: d.supply_price,
          tax: d.tax,
          price: d.price,
          balance: d.balance,
          field: d.field,
          desc: d.desc,
        }
        items.push(data);
      });
      export2csv.export(items, fields, '거래내역리스트');
    },
    handleClickExcel() {
      this.excel_flag = true;
      let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">'
      tab_text += '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">'
      tab_text += '<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
      tab_text += '<x:Name>'+ this.title +'</x:Name>'
      tab_text += '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>'
      tab_text += '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>'
      tab_text += "<table>"
      const temp = document.getElementById('excel_table').innerHTML;
      tab_text += temp;
      tab_text += '</table></body></html>';
      const fileName = this.title + '.xls';
      const a_tag = document.createElement('a');
      const blob = new Blob([tab_text], { type: 'application/vnd.ms-excel;charset=utf-8;' });
      a_tag.href = window.URL.createObjectURL(blob);
      a_tag.download = fileName;
      a_tag.click();
    }
  }
};
</script>
<style lang="scss">
.ExpensePrint {
  .table-account {
    tr {
      th {
        width: 80px;
      }
      td {
        min-width: 100px;
      }
    }
  }
  .max-height {
    max-height: 500px;
  }
}
</style>
<style lang="scss" media="print">
.ExpensePrintArea {
  page: landscape;
  table.table-fs12 tr {
    height: 13px;
    line-height: 13px;
  }
  table.table-fs12 .day-sum-row {
    height: 13px;
    line-height: 13px;
  }
  table.table-fs12 tr th,
  table.table-fs12 tr td,
  table.transaction tr td,
  table.transaction tr th,
  .el-dialog__body {
    font-size: 13px;
  }
}
</style>